export class ColoracaoModel {
  id: string;
  nome_pt: string;
  nome_en: string;
  nome_es: string;
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-coloracao/coloracao.model.ts